import { Apis, Labels } from '../../app.constants';
import APIService from '../../APIService';

const WebhookAction = () => {

  const getBotAuthentication = async (params) => {
    const query = params?.id ? `?id=${encodeURIComponent(params.id)}` : '';
    const res = await APIService.get(`${Apis.botAuthentication}${query}`);
    if (res?.status === 200) return res;
  };

  const createBotAuthentication = async (data) => {
    const res = await APIService.post(`${Apis.botAuthentication}`, data);
    if (res?.status === 201 || res?.status === 200) return res;
  };

  const updateBotAuthentication = async (data) => {
    const res = await APIService.patch(`${Apis.botAuthentication}`, data);
    return res;
  };

  const deleteBotAuthentication = async (id) => {
    const res = await APIService.remove(`${Apis.botAuthentication}?id=${encodeURIComponent(id)}`);
    if (res?.status === 200) return res;
  };

  const upsertBotAuthentication = async (payload) => {
    if (payload?._id) return updateBotAuthentication(payload);
    return createBotAuthentication(payload);
  };

  return {
    getBotAuthentication,
    createBotAuthentication,
    updateBotAuthentication,
    deleteBotAuthentication,
    upsertBotAuthentication,
  };
};

export { WebhookAction };
